import Constants from "./constants";

export default class Utils {
    // Mirrors the server's hideCost_m: ROOT/ADMIN always see the unit price,
    // any other role only when its showUnitPrice flag is not switched off.
    static canSeeUnitPrice(role) {
        if (!role) return false;
        if (Constants.SUPER_ROLE_TYPES.includes(role.type)) return true;
        return role.showUnitPrice !== false;
    }

    static getAvatar(user) {
        try {
            return user.firstName.charAt(0) + user.lastName.charAt(0);
        } catch (err) {}
    }

    static stringToColor = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const color = `hsl(${hash % 360}, 60%, 50%)`;
        return color;
    };

    static getFirstChar(s) { return s.charAt(0); }
    
    static copyToClipboard(text) {
        try {
            navigator.clipboard.writeText(text);
        } catch {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
    }

    static xor = (a, b) => !!(a ^ b);

    static genIdByDateTime() {
        let date = new Date();
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();
        let hour = String(date.getHours()).padStart(2, '0');
        let minute = String(date.getMinutes()).padStart(2, '0');
    
        return `${yyyy}${mm}${dd}${hour}${minute}`;
    }

    static getTimestampDate(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    }

    static getTimestampYear(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let yyyy = date.getFullYear();
        return yyyy;
    }

    static getTimestampMonth(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        return mm;
    }

    static getTimestampDay(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let dd = String(date.getDate()).padStart(2, '0');
        return dd;
    }

    static getTimestampHm(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let hour = String(date.getHours()).padStart(2, '0');
        let minute = String(date.getMinutes()).padStart(2, '0');
        return `${hour}:${minute}`;
    }

    static getTimestampDateHm(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();
        let hour = String(date.getHours()).padStart(2, '0');
        let minute = String(date.getMinutes()).padStart(2, '0');
    
        return `${dd}-${mm}-${yyyy} ${hour}:${minute}`;
    }

    static getYear() {
        let date = new Date();
        let yyyy = date.getFullYear();

        return yyyy;
    }

    static getMonth() {
        let date = new Date();
        let mm = String(date.getMonth() + 1).padStart(2, '0');
    
        return mm;
    }

    static getDay() {
        let date = new Date();
        let dd = String(date.getDate()).padStart(2, '0');
    
        return dd;
    }

    static getMonthYear() {
        let date = new Date();
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();

        return `${mm}/${yyyy}`;
    }

    static getCurrentDate() {
        let date = new Date();
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();

        return `${dd}-${mm}-${yyyy}`;
    }

    static getCurrentTime() {
        let date = new Date();
        let hour = String(date.getHours()).padStart(2, '0');
        let minute = String(date.getMinutes()).padStart(2, '0');
    
        return `${hour}:${minute}`;
    }

    static getCurrentDateISO() {
        let date = new Date();
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();

        return `${yyyy}-${mm}-${dd}`;
    }

    static getTimestampDateISO(timestamp) {
        if (!timestamp) return;
        let date = new Date(timestamp);
        let dd = String(date.getDate()).padStart(2, '0');
        let mm = String(date.getMonth() + 1).padStart(2, '0');
        let yyyy = date.getFullYear();

        return `${yyyy}-${mm}-${dd}`;
    }

    static errorHandling (data) {
        let content = '';
        data.map((item, index) => { if (!item.key) content += `${index + 1}) ${item.value}. ` });

        return content;
    }

    static allowedModule(modules, module) {
        if (!modules) return false;
        if (modules.find(m => m.module === module && m.allow)) return true;
        return false;
    }

    // The first module the role allows, out of `mainModules` in navigation order.
    // Used to decide where "/" goes: the dashboard is a module like any other, so a
    // role without it must land on something it can actually open.
    static allowedModules(modules, mainModules) {
        if (!Array.isArray(mainModules)) return [];
        return mainModules.filter(item => Utils.allowedModule(modules, item.id));
    }

    static homeLink(modules, mainModules, fallback) {
        const first = Utils.allowedModules(modules, mainModules)[0];
        return first?.links?.[0] ?? fallback;
    }

    static allowedModel(permissions, eventType, actionType) {
        if (!permissions) return false;
        if (permissions.find(p => p.model === eventType && p[actionType])) return true;
        return false;
    }

    static truncateText = (text, size) => {
        return text.length > size ? text.slice(0, size) + '...' : text;
    };

    static capitalizeFirstLetter = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    static toggleSidebar() {
        let el = 'body'.trim();
        document.querySelector(el).classList.toggle('toggle-sidebar');
    }

    static numberToTurkmenText(input) {
        let num = typeof input === "string" ? parseFloat(input) : input;
        if (isNaN(num) || num < 0 || num >= 1e15) return "San 0 bilen 1 trilýon arasynda bolmaly.";

        const ones = ["nol", "bir", "iki", "üç", "dört", "bäş", "alty", "ýedi", "sekiz", "dokuz"];
        const teens = ["on", "on bir", "on iki", "on üç", "on dört", "on bäş", "on alty", "on ýedi", "on sekiz", "on dokuz"];
        const tens = ["", "", "ýigrimi", "otuz", "kyrk", "elli", "altmyş", "ýetmiş", "segsen", "togsan"];
        const scales = ["", "müň", "milýon", "milýard", "trilýon"];

        if (num < 0) return "minus"; // Handle negative numbers
        if (num === 0) return "0"; // Handle zero
        const [dollars, cents] = num.toFixed(2).split('.'); // Split dollars and cents

        // Convert dollars to words
        function convertChunk(chunk) {
            if (chunk === "000") return "";

            let result = [];
            const n = parseInt(chunk);

            // Hundreds place
            if (Math.floor(n / 100) > 0) {
                result.push(ones[Math.floor(n / 100)] + " ýüz");
                chunk = (n % 100).toString().padStart(2, '0');
            }

            // Tens and ones place
            const chunkNum = parseInt(chunk);
            if (chunkNum >= 20) {
                result.push(tens[Math.floor(chunkNum / 10)]);
                if (chunkNum % 10 > 0) result.push(ones[chunkNum % 10]);
            }
            else if (chunkNum >= 10) result.push(teens[chunkNum - 10]);
            else if (chunkNum > 0) result.push(ones[chunkNum]);
            return result.join(" ");
        }

        let dollarsNum = parseInt(dollars); // Break number into chunks
        let words = [];

        for (let i = 0; dollarsNum > 0; i++) {
            if (dollarsNum % 1000 !== 0) {
                const chunk = (dollarsNum % 1000).toString().padStart(3, '0');
                const chunkWords = convertChunk(chunk);
                if (chunkWords) words.unshift(chunkWords + (i > 0 ? " " + scales[i] : ""));
            }
            dollarsNum = Math.floor(dollarsNum / 1000);
        }

        // Combine dollar and cent parts
        const dollarWords = words.length ? words.join(" ") + " manat" + (words.join(" ").split(" ")[0] !== "bir" ? "" : "") : "";
        const centWords = cents === "00" ? "00 teňňe" : parseInt(cents) + " teňňe" + (parseInt(cents) !== 1 ? "" : "");
        return (dollarWords + " " + centWords).trim();
    }

    static formatCurrency(amount = 0, currencyCode, locale = 'en-US', minFractionDigits = 2, maxFractionDigits = 2) {
        if (!currencyCode) return;

        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: minFractionDigits,
            maximumFractionDigits: maxFractionDigits,
        });

        return formatter.format(amount);
    }

    static formatNumber(value, locale = 'en-US', options = { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true }) {
        if (value === undefined || value === null) return;
        
        return value.toLocaleString(locale, options);
    }
}